import styled from "styled-components";

export const Container = styled.p`
  font-size: 0.8rem;

  margin-left: 1rem;

  color: ${({ theme }) => theme.colors.attention};
`;
